import { LoadablePaint } from '@confluence/loadable';

export const ShareableLinkSiteAdminConfigurationLoader = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ShareableLinkConfiguration" */ '../common/components/ConfigPage.tsx'
			)
		).ConfigPage,
});
